import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";
import { formatAdminUserAccounts } from "../utils/accountUtils";

const { api } = new APIInstance({ path: "/v1/accounts" });

export const AccountService = {
  getAccounts: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`?${params.toString()}`);
  },

  getAccountById: (accountId) => {
    return api.get(`/${accountId}`);
  },

  getAccountTypes: () => {
    return api.get("/types");
  },

  createAccount: (accountData) => {
    return api.post("", accountData);
  },

  updateAccount: (accountId, accountDetails) => {
    return api.patch(`/${accountId}`, accountDetails);
  },

  deleteAccount: (accountId) => {
    return api.delete(`/${accountId}`);
  },

  getAdminAndUserAccounts: async ({ hasViewAccount, user, companyAdminId, ...filters }) => {
    const accounts = await AccountService.getAccounts({
      ownerUserId: hasViewAccount ? [user.id, companyAdminId] : user.id,
      ...filters,
    });

    return formatAdminUserAccounts(accounts, { user, companyAdminId });
  },
};
